import { render, staticRenderFns } from "./CompositeBox.vue?vue&type=template&id=5c0d7963"
import script from "./CompositeBox.vue?vue&type=script&setup=true&lang=js"
export * from "./CompositeBox.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports